<template>
  <v-responsive>
    <v-container class="fill-height">
      <v-row align="center">
        <v-col>
          <h2 class="display-1">
            {{ myJumbotron.heading }}
          </h2>
          <span class="subheading">{{ myJumbotron.subHeading }}</span>
          <v-list dense>
            <v-list-item
              v-for="element in myJumbotron.elementList"
              :key="element.text"
            >
              <v-list-item-content>
                <v-list-item-title>
                  <v-icon>mdi-check</v-icon>
                  {{ element.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-divider class="my-3" />
          <v-col class="title mb-3">
            {{ myJumbotron.dividerHeading }}
          </v-col>
          <template v-if="myJumbotron.type==='accessRequest'">
            <v-col
              class="xs"
              sm="6"
              md="4"
              lg="3"
            >
              <v-select
                v-model="permissionSelected"
                :items="permissionItems"
                label="Select the permissions you would like"
                single-line
              />
            </v-col>
            <v-btn
              large
              text
              color="primary"
              class="mx-0"
            >
              send request
            </v-btn>
          </template>

          <template v-if="['noTriggerDataset','noTriggerApi','noTriggerFunction'].includes(myJumbotron.type)">
            <v-btn
              large
              color="primary"
              class="mx-0"
              :to="{path : '/projects/'+project+'/create/trigger',query : {function:fn?fn.id:undefined,service:dataset?dataset.hmd_id:api?api.name:undefined,service_type : dataset?'dataset':api?'api':undefined}}"
            >
              Create
            </v-btn>
          </template>

          <template v-if="myJumbotron.type==='noDataset'">
            <v-btn
              large
              color="primary"
              class="mx-0"
              :to="'/projects/'+project+'/create/dataset'"
            >
              Create
            </v-btn>
          </template>

          <template v-if="myJumbotron.type==='noAPI'">
            <v-btn
              large
              color="primary"
              class="mx-0"
              :to="'/projects/'+project+'/create/api'"
            >
              Create
            </v-btn>
          </template>

          <template v-if="myJumbotron.type==='noSchema'">
            <v-btn
              large
              color="primary"
              @click.native="createSchemaTable"
            >
              Create schema
            </v-btn>
          </template>
        </v-col>
      </v-row>
    </v-container>
  </v-responsive>
</template>

<script>
  export default {
    props: {
      myJumbotron: {},
      dataset: {
        type: Object,
        default: () => {
          return {}
        },
      },
      api: {},
      fn: {},
    },
    data () {
      return {
        permissionItems: [
          { text: 'Can view', value: '100' }, // R=1, W=0, M=0
          { text: 'Can edit', value: '110' }, // R=1, W=1, M=0
          { text: 'Can manage', value: '111' }, // R=1, W=1, M=1
        ],
        permissionSelected: {},
      }
    },
    computed: {
      project () {
        return this.$route.params.project
      },
    },
    methods: {
      createSchemaTable () {
        this.$emit('createSchemaTable')
      },
    },
  }
</script>
